module.exports = __webpack_public_path__ + "img/pollution_level_0.214e8b0e.png";